
// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------
import user from '../../../assets/icons/navbar/ic_user.svg';
import analytics from '../../../assets/icons/navbar/ic_analytics.svg';
import account from '../../../assets/icons/navbar/ic_dashboard.svg';
import qrlicense from '../../../assets/icons/navbar/ic_qr_license.svg';
import adminlicense from '../../../assets/icons/navbar/ic_admin_license.svg';
import feedback from '../../../assets/icons/navbar/ic_feedback.svg';
import services from '../../../assets/icons/navbar/ic_services.svg';
import blog from '../../../assets/icons/navbar/ic_blog.svg';

const icon = (name) => <SvgColor src={name} sx={{ width: 1, height: 1 }} />;

// super admin panel

export const adminHeadNavConfig = [
  {
    title: 'dashboard',
    path: '/dashboard',
    icon: icon(analytics),
  },
  {
    title: 'Super Admins',
    path: '/superadmin',
    icon: icon(user),
  },
  {
    title: 'Accounts',
    path: '/accounts',
    icon: icon(account),
  },
];

export const liceneseManagerNavConfig = [
  {
    title: 'dashboard',
    path: '/dashboard',
    icon: icon(analytics),
  },
  {
    title: 'Accounts',
    path: '/accounts',
    icon: icon(account),
  },
  {
    title: 'Customer Admin',
    path: '/adminmanager',
    icon: icon(user),
  },
  {
    title: 'QR License',
    path: '/qrlicense',
    icon: icon(qrlicense),
  },
  {
    title: 'Admin License',
    path: '/adminlicense',
    icon: icon(adminlicense),
  },
];

export const financeControllerNavConfig = [
  {
    title: 'dashboard',
    path: '/dashboard',
    icon: icon(analytics),
  },
  {
    title: 'Accounts',
    path: '/accounts',
    icon: icon(account),
  },
  {
    title: 'Customer Admin',
    path: '/adminmanager',
    icon: icon(user),
  },
  {
    title: 'QR License',
    path: '/qrlicense',
    icon: icon(qrlicense),
  },
  {
    title: 'Admin License',
    path: '/adminlicense',
    icon: icon(adminlicense),
  },
];

export const accountManagerNavConfig = [
  {
    title: 'dashboard',
    path: '/dashboard',
    icon: icon(analytics),
  },
  {
    title: 'Accounts',
    path: '/accounts',
    icon: icon(account),
  },
];

// admin panel

export const adminManagerNavConfig = [
  {
    title: 'dashboard',
    path: '/request-dashboard',
    icon: icon(analytics),
  },
  {
    title: 'Requests',
    path: '/requests',
    icon: icon(services),
  },
  {
    title: 'QR License',
    path: '/qrlicense',
    icon: icon(qrlicense),
  },
  {
    title: 'Modules',
    path: '/modules',
    icon: icon(adminlicense),
  },
  {
    title: 'Feedbacks',
    path: '/feedback-response',
    icon: icon(user),
  },
  {
    title: 'Admin Users',
    path: '/adminuser',
    icon: icon(user),
  },
  {
    title: 'Hospital Information',
    path: '/hospital-information',
    icon: icon(blog),
  },
  {
    title: 'Services',
    path: '/service',
    icon: icon(services),
  },
  {
    title: 'Feedback Questions',
    path: '/feedback',
    icon: icon(feedback),
  },
  
  
];

export const powerUserNavConfig = [
  {
    title: 'dashboard',
    path: '/request-dashboard',
    icon: icon(analytics),
  },
  {
    title: 'Requests',
    path: '/requests',
    icon: icon(services),
  }
];

export const userNavConfig = [
  {
    title: 'dashboard',
    path: '/request-dashboard',
    icon: icon(analytics),
  },
  {
    title: 'Requests',
    path: '/requests',
    icon: icon(services),
  }
];

export const viewerNavConfig = [
  {
    title: 'dashboard',
    path: '/request-dashboard',
    icon: icon(analytics),
  },
  {
    title: 'Requests',
    path: '/requests',
    icon: icon(services),
  },
  {
    title: 'Feedbacks',
    path: '/feedback-response',
    icon: icon(user),
  },
];

